// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-body[data-v-4cdedac5] {
  display: flex;
  margin: 0 auto !important;
}
.modal-body .dateTime[data-v-4cdedac5] {
  display: flex;
  width: 260px;
  justify-content: space-between;
  overflow-y: hidden;
  color: var(--custom-textarea-color);
}
.modal-body .dateTime .date[data-v-4cdedac5] {
  border-bottom: 1px solid var(--list-item-bordercolor);
  color: gray;
  width: 140px;
}
.modal-body .dateTime .time[data-v-4cdedac5] {
  border-bottom: 1px solid var(--list-item-bordercolor);
  color: var(--custom-textarea-color);
  width: 100px;
}
.modal-body .dateTime .time .time-icon[data-v-4cdedac5] {
  margin-bottom: -4px;
}
[data-v-4cdedac5] .date-picker-date,[data-v-4cdedac5] .date-picker-time {
  border: none !important;
  width: 90%;
  outline: none;
  margin: 6px auto auto 5px;
  cursor: pointer;
  color: var(--custom-textarea-color);
  background-color: var(--bg-color);
}
[data-v-4cdedac5] .mx-calendar {
  position: fixed;
  background-color: var(--bg-color);
  border: 1px solid var(--datepicker-border-color);
}
[data-v-4cdedac5] .mx-calendar .disabled,[data-v-4cdedac5] .mx-calendar .disabled:hover {
  background-color: var(--disabled-overlay-bg);
}
[data-v-4cdedac5] .mx-calendar-icon {
  color: var(--toolbtn-color);
}
[data-v-4cdedac5] .mx-datepicker-footer {
  position: fixed;
  margin-left: 88px;
  background-color: var(--bg-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/scheduleSendMessage.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,qDAAqD;EACrD,WAAW;EACX,YAAY;AACd;AACA;EACE,qDAAqD;EACrD,mCAAmC;EACnC,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,mCAAmC;EACnC,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,gDAAgD;AAClD;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC","sourcesContent":[".modal-body[data-v-4cdedac5] {\n  display: flex;\n  margin: 0 auto !important;\n}\n.modal-body .dateTime[data-v-4cdedac5] {\n  display: flex;\n  width: 260px;\n  justify-content: space-between;\n  overflow-y: hidden;\n  color: var(--custom-textarea-color);\n}\n.modal-body .dateTime .date[data-v-4cdedac5] {\n  border-bottom: 1px solid var(--list-item-bordercolor);\n  color: gray;\n  width: 140px;\n}\n.modal-body .dateTime .time[data-v-4cdedac5] {\n  border-bottom: 1px solid var(--list-item-bordercolor);\n  color: var(--custom-textarea-color);\n  width: 100px;\n}\n.modal-body .dateTime .time .time-icon[data-v-4cdedac5] {\n  margin-bottom: -4px;\n}\n[data-v-4cdedac5] .date-picker-date,[data-v-4cdedac5] .date-picker-time {\n  border: none !important;\n  width: 90%;\n  outline: none;\n  margin: 6px auto auto 5px;\n  cursor: pointer;\n  color: var(--custom-textarea-color);\n  background-color: var(--bg-color);\n}\n[data-v-4cdedac5] .mx-calendar {\n  position: fixed;\n  background-color: var(--bg-color);\n  border: 1px solid var(--datepicker-border-color);\n}\n[data-v-4cdedac5] .mx-calendar .disabled,[data-v-4cdedac5] .mx-calendar .disabled:hover {\n  background-color: var(--disabled-overlay-bg);\n}\n[data-v-4cdedac5] .mx-calendar-icon {\n  color: var(--toolbtn-color);\n}\n[data-v-4cdedac5] .mx-datepicker-footer {\n  position: fixed;\n  margin-left: 88px;\n  background-color: var(--bg-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
